<template>
  <v-container>
    <v-row class="first-row" justify="center">
      <h2>Tech Stack</h2>
    </v-row>
    <v-layout wrap justify-left>
      <v-flex xs8 sm7 md6 lg4 xl3 offset-xs2 offset-md0>
        <v-row justify="center">
          <h3>Language</h3>
        </v-row>
        <v-card
          class="skill-card"
          outlined
        >
          <v-row justify="center">
            <v-list>
              <v-list-item
                v-for="(item, index) in this.teckStacks['Language']"
                :key="index"
                ripple
              >
                <v-avatar
                  width="64"
                  height="64"
                  rounded="circle"
                  color="amber lighten-5"
                >
                  <v-img 
                    height="64"
                    width="64"
                    :src="item.imgPath">
                  </v-img>
                </v-avatar>
                <v-list-item-content>
                  <span class="skilName">{{item.skilName}}</span>
                  <v-rating
                    :value="item.rating"
                    color="amber"
                    length="5"
                    dense
                    half-increments
                    readonly
                  ></v-rating>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-row>
        </v-card>
      </v-flex>
      <v-flex xs8 sm7 md6 lg4 xl3 offset-xs2 offset-md0>
        <v-row justify="center">
            <h3>Framework</h3>
        </v-row>
        <v-card
          class="skill-card"
          outlined
        >
          <v-row justify="center">
            <v-list>
              <v-list-item
                v-for="(item, index) in this.teckStacks['Framework']"
                :key="index"
                ripple
              >
                <v-avatar
                  width="64"
                  height="64"
                  rounded="circle"
                  color="amber lighten-5"
                >
                  <v-img 
                    height="64"
                    width="64"
                    :src="item.imgPath">
                  </v-img>
                </v-avatar>
                <v-list-item-content>
                  <span class="skilName">{{item.skilName}}</span>
                  <v-rating
                    :value="item.rating"
                    color="amber"
                    length="5"
                    dense
                    half-increments
                    readonly
                  ></v-rating>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-row>
        </v-card>
      </v-flex>
      <v-flex xs8 sm7 md6 lg4 xl3 offset-xs2 offset-md0 >
        <v-row justify="center">
          <h3>OS</h3>
        </v-row>
        <v-card
          class="skill-card"
          outlined
        >
          <v-row justify="center">
            <v-list>
              <v-list-item
                v-for="(item, index) in this.teckStacks['OS']"
                :key="index"
                ripple
              >
                <v-avatar
                  width="64"
                  height="64"
                  rounded="circle"
                  color="amber lighten-5"
                >
                  <v-img 
                    height="64"
                    width="64"
                    :src="item.imgPath">
                  </v-img>
                </v-avatar>
                <v-list-item-content>
                  <span class="skilName">{{item.skilName}}</span>
                  <v-rating
                    :value="item.rating"
                    color="amber"
                    length="5"
                    dense
                    half-increments
                    readonly
                  ></v-rating>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-row>
        </v-card>
      </v-flex>
      <v-flex xs8 sm7 md6 lg4 xl3 offset-xs2 offset-md0 >
        <v-row justify="center">
          <h3>DB</h3>
        </v-row>
        <v-card
          class="skill-card"
          outlined
        >
          <v-row justify="center">
            <v-list>
              <v-list-item
                v-for="(item, index) in this.teckStacks['DB']"
                :key="index"
                ripple
              >
                <v-avatar
                  width="64"
                  height="64"
                  rounded="circle"
                  color="amber lighten-5"
                >
                  <v-img 
                    height="64"
                    width="64"
                    :src="item.imgPath">
                  </v-img>
                </v-avatar>
                <v-list-item-content>
                  <span class="skilName">{{item.skilName}}</span>
                  <v-rating
                    :value="item.rating"
                    color="amber"
                    length="5"
                    dense
                    half-increments
                    readonly
                  ></v-rating>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-row>
        </v-card>
      </v-flex>
      <v-flex xs8 sm7 md6 lg4 xl3 offset-xs2 offset-md0>
        <v-row justify="center">
          <h3>Tool</h3>
        </v-row>
        <v-card
          class="skill-card"
          outlined
        >
          <v-row justify="center">
            <v-list>
              <v-list-item
                v-for="(item, index) in this.teckStacks['Tool']"
                :key="index"
                ripple
              >
                <v-avatar
                  width="64"
                  height="64"
                  rounded="circle"
                  color="amber lighten-5"
                >
                  <v-img 
                    height="64"
                    width="64"
                    :src="item.imgPath">
                  </v-img>
                </v-avatar>
                <v-list-item-content>
                  <span class="skilName">{{item.skilName}}</span>
                  <v-rating
                    :value="item.rating"
                    color="amber"
                    length="5"
                    dense
                    half-increments
                    readonly
                  ></v-rating>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style scoped>
  /* 各ページの行頭のmarginを揃える */
  .first-row{
    margin-top: 20px;
  }
  /* v-cardのデフォルトのマージン値を修正 */
  .skill-card{
    margin-top: 5px !important;
    margin-bottom: 20px !important;
  }
  /* スキル名の色を変更しレーティングの位置と合わせる */
  .skilName{
    margin-left: 5px;
  }
  h2{
    color: white;
    text-shadow: 1px 2px 3px #808080;
  }
  h3{
    color: white;
    text-shadow: 1px 2px 3px #808080;
  }
</style>

<script>
  export default {
    name: 'Skill',
    data: () => ({
      skillMaxLen: 0,
      teckStacks: {
        'Language':
        [
          {
            'skilName': 'C',
            'imgPath': '/techStacks/langC.svg',
            'rating': 1.5,
          },
          {
            'skilName': 'C#',
            'imgPath': '/techStacks/langCSharp.svg',
            'rating': 2.0,
          },
          {
            'skilName': 'Java',
            'imgPath': '/techStacks/langJava.svg',
            'rating': 2.0,
          },
          {
            'skilName': 'Ruby',
            'imgPath': '/techStacks/langRuby.svg',
            'rating': 2.0,
          }
        ],
        'Framework':
        [
          {
            'skilName': 'Ruby on Rails',
            'imgPath': '/techStacks/rails.svg',
            'rating': 2.0,
          },
          {
            'skilName': 'Vuejs',
            'imgPath': '/techStacks/vueJs.svg',
            'rating': 2.5,
          }
        ],
        'OS':
        [
          {
            'skilName': 'Windows 10',
            'imgPath': '/techStacks/windows.svg',
            'rating': 3.0,
          },
          {
            'skilName': 'Ubuntu 16.04',
            'imgPath': '/techStacks/ubuntu.png',
           'rating': 2.5,
          },
        ],
        'DB':
        [
          {
            'skilName': 'MySQL',
            'imgPath': '/techStacks/dbMySql.svg',
            'rating': 2.0,
          },
          {
            'skilName': 'DynamoDB',
            'imgPath': '/techStacks/dynamoDB.png',
            'rating': 2.0,
          }
        ],
        'Tool':
        [
          {
            'skilName': 'Git',
            'imgPath': '/techStacks/git.svg',
            'rating': 2.5,
          },
        ]
        // 'Cloud':
        // [
        //   {
        //     'skilName': 'C',
        //     'imgPath': '/techStacks/langC.svg',
        //     'rating': 1.0,
        //   }
        // ],
      },
    }),
    beforeMount(){
      // 各カテゴリ内のスキル数の最大値を取得
      let maxLen = 0;
      for(let key in this.teckStacks){
        if(this.teckStacks[key].length > maxLen){
          maxLen = this.teckStacks[key].length
        }
      }
      this.maxLen = maxLen
    }
  }
</script>
